export const toSegments = segments => segments.map(toSegment)

export const toSegment = segment => ({
  value: segment.id,
  label: segment.name,
  system: segment.system
})
